export const nl = [
  'de',
  'en',
  'van',
  'ik',
  'te',
  'dat',
  'die',
  'in',
  'een',
  'hij',
  'het',
  'niet',
  'zijn',
  'is',
  'was',
  'op',
  'aan',
  'met',
  'als',
  'voor',
  'had',
  'er',
  'maar',
  'om',
  'hem',
  'dan',
  'zou',
  'of',
  'wat',
  'mijn',
  'men',
  'dit',
  'zo',
  'door',
  'over',
  'ze',
  'zich',
  'bij',
  'ook',
  'tot',
  'je',
  'mij',
  'uit',
  'der',
  'daar',
  'haar',
  'naar',
  'heb',
  'hoe',
  'heeft',
  'hebben',
  'deze',
  'u',
  'want',
  'nog',
  'zal',
  'me',
  'zij',
  'nu',
  'ge',
  'geen',
  'omdat',
  'iets',
  'worden',
  'toch',
  'al',
  'waren',
  'veel',
  'meer',
  'doen',
  'toen',
  'moet',
  'ben',
  'zonder',
  'kan',
  'hun',
  'dus',
  'alles',
  'onder',
  'ja',
  'eens',
  'hier',
  'wie',
  'werd',
  'altijd',
  'doch',
  'wordt',
  'wezen',
  'kunnen',
  'ons',
  'zelf',
  'tegen',
  'na',
  'reeds',
  'wil',
  'kon',
  'niets',
  'uw',
  'iemand',
  'geweest',
  'andere'
]

export const en = [
  'i',
  'me',
  'my',
  'myself',
  'we',
  'our',
  'ours',
  'ourselves',
  'you',
  'your',
  'yours',
  'yourself',
  'yourselves',
  'he',
  'him',
  'his',
  'himself',
  'she',
  'her',
  'hers',
  'herself',
  'it',
  'its',
  'itself',
  'they',
  'them',
  'their',
  'theirs',
  'themselves',
  'what',
  'which',
  'who',
  'whom',
  'this',
  'that',
  'these',
  'those',
  'am',
  'is',
  'are',
  'was',
  'were',
  'be',
  'been',
  'being',
  'have',
  'has',
  'had',
  'having',
  'do',
  'does',
  'did',
  'doing',
  'would',
  'should',
  'could',
  'ought',
  "i'm",
  "you're",
  "he's",
  "she's",
  "it's",
  "we're",
  "they're",
  "i've",
  "you've",
  "we've",
  "they've",
  "i'd",
  "you'd",
  "he'd",
  "she'd",
  "we'd",
  "they'd",
  "i'll",
  "you'll",
  "he'll",
  "she'll",
  "we'll",
  "they'll",
  "isn't",
  "aren't",
  "wasn't",
  "weren't",
  "hasn't",
  "haven't",
  "hadn't",
  "doesn't",
  "don't",
  "didn't",
  "won't",
  "wouldn't",
  "shan't",
  "shouldn't",
  "can't",
  'cannot',
  "couldn't",
  "mustn't",
  "let's",
  "that's",
  "who's",
  "what's",
  "here's",
  "there's",
  "when's",
  "where's",
  "why's",
  "how's",
  'a',
  'an',
  'the',
  'and',
  'but',
  'if',
  'or',
  'because',
  'as',
  'until',
  'while',
  'of',
  'at',
  'by',
  'for',
  'with',
  'about',
  'against',
  'between',
  'into',
  'through',
  'during',
  'before',
  'after',
  'above',
  'below',
  'to',
  'from',
  'up',
  'down',
  'in',
  'out',
  'on',
  'off',
  'over',
  'under',
  'again',
  'further',
  'then',
  'once',
  'here',
  'there',
  'when',
  'where',
  'why',
  'how',
  'all',
  'any',
  'both',
  'each',
  'few',
  'more',
  'most',
  'other',
  'some',
  'such',
  'no',
  'nor',
  'not',
  'only',
  'own',
  'same',
  'so',
  'than',
  'too',
  'very',
  'will'
]

export const de = [
  'aber',
  'alle',
  'allem',
  'allen',
  'aller',
  'alles',
  'als',
  'also',
  'am',
  'an',
  'ander',
  'andere',
  'anderem',
  'anderen',
  'anderer',
  'anderes',
  'anderm',
  'andern',
  'anderr',
  'anders',
  'auch',
  'auf',
  'aus',
  'bei',
  'bin',
  'bis',
  'bist',
  'da',
  'damit',
  'dann',
  'der',
  'den',
  'des',
  'dem',
  'die',
  'das',
  'daß',
  'derselbe',
  'derselben',
  'denselben',
  'desselben',
  'demselben',
  'dieselbe',
  'dieselben',
  'dasselbe',
  'dazu',
  'dein',
  'deine',
  'deinem',
  'deinen',
  'deiner',
  'deines',
  'denn',
  'derer',
  'dessen',
  'dich',
  'dir',
  'du',
  'dies',
  'diese',
  'diesem',
  'diesen',
  'dieser',
  'dieses',
  'doch',
  'dort',
  'durch',
  'ein',
  'eine',
  'einem',
  'einen',
  'einer',
  'eines',
  'einig',
  'einige',
  'einigem',
  'einigen',
  'einiger',
  'einiges',
  'einmal',
  'er',
  'ihn',
  'ihm',
  'es',
  'etwas',
  'euer',
  'eure',
  'eurem',
  'euren',
  'eurer',
  'eures',
  'für',
  'gegen',
  'gewesen',
  'hab',
  'habe',
  'haben',
  'hat',
  'hatte',
  'hatten',
  'hier',
  'hin',
  'hinter',
  'ich',
  'mich',
  'mir',
  'ihr',
  'ihre',
  'ihrem',
  'ihren',
  'ihrer',
  'ihres',
  'euch',
  'im',
  'in',
  'indem',
  'ins',
  'ist',
  'jede',
  'jedem',
  'jeden',
  'jeder',
  'jedes',
  'jene',
  'jenem',
  'jenen',
  'jener',
  'jenes',
  'jetzt',
  'kann',
  'kein',
  'keine',
  'keinem',
  'keinen',
  'keiner',
  'keines',
  'können',
  'könnte',
  'machen',
  'man',
  'manche',
  'manchem',
  'manchen',
  'mancher',
  'manches',
  'mein',
  'meine',
  'meinem',
  'meinen',
  'meiner',
  'meines',
  'mit',
  'muss',
  'musste',
  'nach',
  'nicht',
  'nichts',
  'noch',
  'nun',
  'nur',
  'ob',
  'oder',
  'ohne',
  'sehr',
  'sein',
  'seine',
  'seinem',
  'seinen',
  'seiner',
  'seines',
  'selbst',
  'sich',
  'sie',
  'ihnen',
  'sind',
  'so',
  'solche',
  'solchem',
  'solchen',
  'solcher',
  'solches',
  'soll',
  'sollte',
  'sondern',
  'sonst',
  'über',
  'um',
  'und',
  'uns',
  'unse',
  'unsem',
  'unsen',
  'unser',
  'unses',
  'unter',
  'viel',
  'vom',
  'von',
  'vor',
  'während',
  'war',
  'waren',
  'warst',
  'was',
  'weg',
  'weil',
  'weiter',
  'welche',
  'welchem',
  'welchen',
  'welcher',
  'welches',
  'wenn',
  'werde',
  'werden',
  'wie',
  'wieder',
  'will',
  'wir',
  'wird',
  'wirst',
  'wo',
  'wollen',
  'wollte',
  'würde',
  'würden',
  'zu',
  'zum',
  'zur',
  'zwar',
  'zwischen'
]

const stopwords = [...nl, ...en, ...de]
export default stopwords
